import type { PaymentMethod } from '../../services/commonCheckout/types/PaymentMethod';
import type { PaymentMethodSessionOutcome } from '../../services/commonCheckout/types/SessionOutcome/PaymentMethodSessionOutcome';
import type { PaymentMethodType } from '../../services/customer/types';

export const transformPaymentMethodToPaymentMethodSessionOutcome =
  (
    paymentMethod: PaymentMethod<PaymentMethodType>,
  ): PaymentMethodSessionOutcome | null => {
    const {
      id,
      status,
      zipCode,
      default: isDefault,
      nickname,
      warning,
      sourceProvider,
    } = paymentMethod;

    if (paymentMethod.paymentMethodType === 'CARD') {
      const narrowedCardPaymentMethod =
        paymentMethod as PaymentMethod<'CARD'>;
        const {
          vendorPaymentMethodFingerprint: _,
          ...remainingPaymentMethodDetails
        } = narrowedCardPaymentMethod.paymentMethodDetails;

      return {
        id,
        sourceProvider,
        paymentMethodType:
          narrowedCardPaymentMethod.paymentMethodType,
        paymentMethodDetails: remainingPaymentMethodDetails,
        card: remainingPaymentMethodDetails,
        default: isDefault,
        nickname,
        warning,
        zipCode,
        status,
      };
    }

    if (paymentMethod.paymentMethodType === 'BANK_ACCOUNT') {
      const narrowedBankPaymentMethod =
        paymentMethod as PaymentMethod<'BANK_ACCOUNT'>;

      const {
        vendorPaymentMethodFingerprint: _,
        accountNumber: __,
        ...remainingPaymentMethodDetails
      } = narrowedBankPaymentMethod.paymentMethodDetails;

      return {
        id,
        paymentMethodType:
          narrowedBankPaymentMethod.paymentMethodType,
        sourceProvider,
        paymentMethodDetails: {
          type: 'BANK_ACCOUNT',
          nameOnAccount:
            remainingPaymentMethodDetails.nameOnAccount,
          status: remainingPaymentMethodDetails.status,
          routingNumber:
            remainingPaymentMethodDetails.routingNumber,
          bankName: remainingPaymentMethodDetails.bankName,
          accountType: remainingPaymentMethodDetails.accountType,
          accountHolderType:
            remainingPaymentMethodDetails.accountHolderType,
          last4: remainingPaymentMethodDetails.last4,
        },
        default: isDefault,
        nickname,
        warning,
        zipCode,
        status,
      };
    }

    return null;
  };
